import React from 'react';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss';

function Footer() {
  return (
    <footer>
      <div>
        <a
          href="https://github.com/francis-paul-code"
          target="_blank"
          rel="noreferrer"
        >
          <GitHubIcon />
        </a>
        <a
          href="https://www.linkedin.com/in/francispaulmusango/"
          target="_blank"
          rel="noreferrer"
        >
          <LinkedInIcon />
        </a>
      </div>
      <p>
        A portfolio for{' '}
        <a href="https://francismusango.nguro.com/" target="_blank" rel="noreferrer">
          Francis Musango
        </a>
      </p>
    </footer>
  );
}

export default Footer;
